export enum ReportIncidentNames {
	incidentType = 'incidentType',
	details = 'details',
	uploadPhoto = 'uploadPhoto',
	assignTo = 'assignTo',
  typeId = 'typeId',
}
